import { NextFetchEvent, NextRequest } from 'next/server';

import { MiddlewareFactory } from './type';

// Credentialed CORS allowlist (`Access-Control-Allow-Credentials: true` 와 함께 사용).
// wildcard 서브도메인 매칭을 쓰지 않는 이유:
// - takeover 된 dangling subdomain 또는 3rd-party 위탁 호스팅 (Typeform 등) 에서
//   credentialed cross-origin 응답이 누출되는 것을 차단하기 위함.
// - 현재 노출 surface 에는 token/refresh 같은 민감 엔드포인트가 포함됨.
// 새 MRT 앱이 자체 서브도메인으로 배포될 때 ALLOWED_SUBDOMAINS 에 추가하면 된다.
const ALLOWED_SUBDOMAINS = [
  'www',
  'accommodation',
  'air-web',
  'auth',
  'community',
  'experiences',
  'flights',
  'help',
  'main',
  'member',
  'mypack',
  'order',
  'partner',
  'promotion',
  'remote',
  'reservations',
  'support',
  'transportation',
] as const;

const ENV_DOMAINS = [
  'myrealtrip',
  'dev-myrealtrip',
  'dev01-myrealtrip',
  'dev02-myrealtrip',
  'test-myrealtrip',
  'test01-myrealtrip',
  'test02-myrealtrip',
  'stage-myrealtrip',
] as const;

const allowedPattern = new RegExp(
  `^https?:\\/\\/(${ALLOWED_SUBDOMAINS.join('|')})\\.(${ENV_DOMAINS.join('|')})\\.(com|net)$`,
);

export function isAllowedCorsOrigin(origin: string | null | undefined): boolean {
  if (!origin) return false;
  return allowedPattern.test(origin);
}

export const corsMiddleware: MiddlewareFactory = (next, response) => {
  return (req: NextRequest, event: NextFetchEvent) => {
    const origin = req.headers.get('origin');

    if (isAllowedCorsOrigin(origin)) {
      response.headers.set('Access-Control-Allow-Origin', origin as string);
      response.headers.set('Access-Control-Allow-Credentials', 'true');
      response.headers.set('Access-Control-Allow-Methods', 'GET,OPTIONS,PATCH,DELETE,POST,PUT');
      response.headers.set(
        'Access-Control-Allow-Headers',
        'X-CSRF-Token, X-Requested-With, Accept, Content-Type, Authorization',
      );

      // Preflight 요청인 경우 처리
      if (req.method === 'OPTIONS') {
        return new Response(null, {
          status: 200,
          headers: response.headers,
        });
      }
    }

    return next(req, event);
  };
};
